import { TapGesture, PanGesture, PinchPanRotateGesture, PressGesture } from '@/prototyping/pointer-input';
import { JsonRpcModule } from '../../jrpc/module';

export class InputModule extends JsonRpcModule {
    sendTap(payload: TapGesture) {
        this.channel.notify("Input.Tap", [payload]);
    }

    sendPan(payload: PanGesture) {
        this.channel.notify("Input.Pan", [payload]);
    }

    sendPress(payload: PressGesture) {
        this.channel.notify("Input.Press", [payload]);
    }

    sendPinchPanRotate(payload: PinchPanRotateGesture) {
        this.channel.notify("Input.PinchPanRotate", [payload]);
    }
}
